import axios from "axios";

export const getArticlesFromApi = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/blogs`,
      {
        params: { limit: 10, page: 1 },
      }
    );

    return response.data.results; // ⬅️ devolvemos toda la data tal como viene
  } catch (error) {
    console.error("❌ Error al obtener artículos:", error);
    return [];
  }
};
